import React, { useContext } from "react";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";

import GlobalContext from "../Hooks/globalContext";

import Admin from "../Routes/Admin";
import Login from "../Routes/Login";

const LoginRoutes = ({ user }) => {
  const history = useHistory();
  return (
    <>
      <Switch>
        <Route exact path="/" component={Admin} />
        <Redirect from="*" to="/" />
      </Switch>
    </>
  );
};

const LogoutRoutes = () => {
  return (
    <Switch>
      <Route exact path="/" component={Login} />
      <Redirect from="*" to="/" />
    </Switch>
  );
};

const AppRouter = () => {
  const { isLogin, user } = useContext(GlobalContext);
  return isLogin.state ? <LoginRoutes user={user} /> : <LogoutRoutes />;
};

export default AppRouter;
